import { render, staticRenderFns } from "./base-result.vue?vue&type=template&id=3169098e&scoped=true&"
import script from "./base-result.vue?vue&type=script&lang=js&"
export * from "./base-result.vue?vue&type=script&lang=js&"
import style0 from "./base-result.vue?vue&type=style&index=0&id=3169098e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3169098e",
  null
  
)

export default component.exports